import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PacienteComponent } from './subpages/paciente/paciente.component';
import { CartaoInfoComponent } from './subpages/cartao-info/cartao-info.component';
import { ConsultasComponent } from './subpages/consultas/consultas.component';
import { CadernetaComponent } from './subpages/caderneta/caderneta.component';
import { CartaoAnterioresComponent } from './subpages/cartao-anteriores/cartao-anteriores.component';
import { EditarPerfilComponent } from '../paciente/subpages/editar-perfil/editar-perfil.component';
import { DadosConsultaComponent } from './subpages/dados-consulta/dados-consulta.component';
import { RoleGuard } from 'app/core/guards/role.guard';

const routes: Routes = [
  {
    path: 'paciente',
    component: PacienteComponent,
    canActivate: [RoleGuard],
    data: { roles: ['paciente'] }
  },
  {
    path: 'paciente-informacao',
    component: CartaoInfoComponent,
    canActivate: [RoleGuard],
    data: { roles: ['paciente'] }
  },
  {
    path: 'paciente-consultas',
    component: ConsultasComponent,
    canActivate: [RoleGuard],
    data: { roles: ['paciente'] }
  },
  {
    path: 'caderneta-gestante',
    component: CadernetaComponent,
    canActivate: [RoleGuard],
    data: { roles: ['paciente'] }
  },
  {
    path: 'cartoes-anteriores',
    component: CartaoAnterioresComponent,
    canActivate: [RoleGuard],
    data: { roles: ['paciente'] }
  },
  {
    path: 'editar-perfil-paciente',
    component: EditarPerfilComponent,
    canActivate: [RoleGuard],
    data: { roles: ['paciente'] }
  },
  {
    path: 'paciente-dados-consulta',
    component: DadosConsultaComponent,
    canActivate: [RoleGuard],
    data: { roles: ['paciente'] }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PacienteRoutingModule { }
